"use client";
import styles from "./socialMediaIcons.module.scss";

type SocialLink = {
  name: string;
  href: string;
  className: string;
};

const socialLinks: SocialLink[] = [
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/net32-inc/posts/?feedView=all",
    className: styles.linkedinLink,
  },
  { name: "Instagram", href: "https://www.instagram.com/net32inc", className: styles.instagramLink },
  { name: "YouTube", href: "https://www.youtube.com/user/Net32Inc", className: styles.youtubeLink },
  { name: "Facebook", href: "https://www.facebook.com/Net32/#", className: styles.facebookLink },
  { name: "Twitter", href: "https://x.com/Net32Inc", className: styles.twitterLink },
];

type SocialMediaIconProps = { className?: string };

export default function SocialMediaIcon({ className }: SocialMediaIconProps) {
  return (
    <div className={`${styles.socialMediaFooterIcons} ${className ?? ""}`}>
      {socialLinks.map(({ name, href, className: linkClass }) => (
        <a key={name} className={linkClass} href={href} target="_blank" rel="noopener noreferrer" aria-label={name}>
          {name}
        </a>
      ))}
    </div>
  );
}
